import Notification from './Notification';
export var handleServiceError = function (error) {
    var _a, _b, _c;
    var status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
    if (status === 403) {
        Notification().Notify.failure("Usuário não tem permissão para executar essa ação!");
    }
    else if (status === 400) {
        Notification().Loading.remove();
        Notification().Notify.failure(error.response.data.error);
    }
    else if (status === 422) {
        Notification().Notify.failure(error.response.data.error);
    }
    else if ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) {
        Notification().Notify.failure(error.response.data.error);
    }
    else {
        Notification().Notify.failure((error === null || error === void 0 ? void 0 : error.message) || "Erro desconhecido.");
    }
};
function ErrorHandler(_a) {
    var error = _a.error, serviceError = _a.serviceError;
    handleServiceError(error);
    return null;
}
export default ErrorHandler;
